import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./DeleteSelectedModal.module.css";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { deleteProjectMongo } from "../../../Services/projects";
import { themeColors } from "../../theme";
import { motion } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";


type props = {
    open: boolean;
    close: () => void;
    data: any;
    totalData: any;
    organization_id: any;
    clearSelectedRowsData?: () => void;
    theme: any;
    organizationId: string;
    user: any;
    organizationData:any;
    authToken:any;
    panel?:any;
    selectedRows?: any[];
};
const dropIn = {
    hidden: {
        y: "-100vh",
        opacity: 1,
    },
    visible: {
        y: "0",
        opacity: 1,
        transition: {
            duration: 1,
            type: "spring",
            damping: 25,
            stiffness: 500,
        },
    },
};

const DeleteProjectSelectedModal: FunctionComponent<props> = ({
    open,
    close,
    clearSelectedRowsData,
    data,
    totalData,
    organization_id,
    theme,
    organizationData,
    user,
    authToken,
    panel,
    selectedRows
}) => {
    // console.log("organizationId",user)
    const [load, setLoad] = useState(false);
    const dispatcher = useDispatch();

      const deleteProject = () => {
        // console.log("deleteProjectFirebase_Real")
        if (data) {
            let deleteProjects: any[] = [];
            data.map((item: any) => {
                if (item.project_status === "Not Launch" || item.project_status === "Not Launched" || item.project_status==="INTERMEDIATE" || item.project_status ==="Un-Available") {
                    deleteProjects.push(item);
                }
            })
            // console.log("delete Ids",deleteProjectIds)
            deleteProjectMongo(
                deleteProjects,
                dispatcher,
                (item) => setLoad(item),
                authToken,
                close,
                clearSelectedRowsData
            ) 
        }     
    };


      
    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
    return (
        <>
            {load && <Loading />}
            <Backdrop>
                <motion.div
                    key="modal"
                    className="card p-4 shadow rounded"
                    style={{
                        position: "absolute", maxHeight: "400px",
                        ...containerStyles
                    }}
                    variants={dropIn}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <h6>Delete Selected Records</h6>
                    <div className={styles.container}>
                        <ol>
                            {data.filter((i: any) => (i.project_status === "Not Launch" || i.project_status === "INTERMEDIATE"))?.map((dat: any) => (
                                <li>{dat.project_name}</li>
                            ))}
                        </ol>
                    </div>
                    <div className={styles.buttonView}>
                        <button className={styles.cancelButton} onClick={close}>
                            Cancel
                        </button>
                        <button className={styles.saveButton} 
                        onClick={
                            deleteProject
                        //     (!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
                        // deleteProjectFirebase_Real
                        // :
                        // deleteProjectFirebase
                    }
                        >
                            Delete
                        </button>
                    </div>
                </motion.div>
            </Backdrop>
        </>
    );
};
const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode,
        organizationId: state.organization.id,
        user: state.user.data,
        organizationData: state.organization.organizationData,
        authToken:state.user.authToken,
    };
};
export default connect(mapStateToProps)(DeleteProjectSelectedModal);
